export const ROOT_CATEGORY_ID = 1;
